module.exports = __webpack_public_path__ + "static/img/rank_background2.49a1136b.png";